export enum ProjectsSupplierDetailViewTab {
  COWORKERS = 'coworkers',
  CONTENT_TYPES = 'contentTypes',
  CHECK_BOT = 'checkBotConfigs',
}
